import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import store from '@/store'
const environment = store.state.env.mode
if ('local' !== environment) {
  Sentry.init({
    Vue,
    dsn: 'https://6ee44c51bce44e97b4b6f0421302a7e1@o140193.ingest.sentry.io/4504364177620992',
    environment,
    integrations: [
      new BrowserTracing({
        //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        //   tracePropagationTargets: ['localhost', 'buy', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}
